import Header from './components/Header';
import Hero from './components/Hero';
import SectionComments from './components/SectionComments';
import SectionAbout from './components/SectionAbout';
import SectionContact from './components/SectionContact';
import SectionCards from './components/SectionCards';
import SectionApp from './components/SectionApp';
import SectionMedia from './components/SectionMedia';
import SectionIndex from './components/SectionIndex';
import SectionFeatures from './components/SectionFeatures';
import SectionTopics from './components/SectionTopics';
import SectionRanking from './components/SectionRanking';
import SectionUpdates from './components/SectionUpdates';
import SectionFAQ from './components/SectionFAQ';
import SectionCarousel from './components/SectionCarousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionComments />
        <SectionAbout />
        <SectionContact />
        <SectionCards />
        <SectionApp />
        <SectionMedia />
        <SectionIndex />
        <SectionFeatures />
        <SectionTopics />
        <SectionRanking />
        <SectionUpdates />
        <SectionFAQ />
        <SectionCarousel />
      </main>
      <Footer />
    </>
  );
}